/**
 * EntityCardBlock — the data contract for entity detail card components.
 *
 * This is a pure TypeScript file with zero framework imports.
 * Backend tool schemas (Zod) should mirror these types.
 */

export interface EntityCardField {
  label: string;
  value: string | number | boolean;
  type?: 'text' | 'number' | 'currency' | 'date' | 'percent' | 'status' | 'email' | 'phone';
  status_color?: string;
}

export interface EntityCardProgress {
  label: string;
  value: number;
  color?: string;
}

export interface EntityCardAction {
  label: string;
  href: string;
}

export interface EntityCardBlock {
  entity_type: string;
  title: string;
  subtitle?: string;
  deep_link?: string;
  fields: EntityCardField[];
  progress?: EntityCardProgress;
  tags?: string[];
  actions?: EntityCardAction[];
}

export function isValidEntityCardBlock(data: unknown): data is EntityCardBlock {
  if (!data || typeof data !== 'object') return false;
  const d = data as Record<string, unknown>;
  return (
    typeof d.entity_type === 'string' &&
    typeof d.title === 'string' &&
    Array.isArray(d.fields) &&
    d.fields.length > 0
  );
}
